module.exports = "<app-visit [requestType]=\"requestType\" [title]=\"title\"></app-visit>\n"